import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as s } from "react";
import { I as a } from "../../../../IconBase-CxZyIWw2.js";
const i = s((t, o) => /* @__PURE__ */ e.jsx(
  a,
  {
    ref: o,
    ...t,
    image: (r) => /* @__PURE__ */ e.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        viewBox: "0 0 48 48",
        ...r,
        children: [
          /* @__PURE__ */ e.jsx(
            "path",
            {
              fill: "#1D1D44",
              d: "M9.76 14.4 4.87 9.3a3.13 3.13 0 1 1 4.52-4.33l.36.38.36-.38a3.14 3.14 0 0 1 4.43-.1 3.13 3.13 0 0 1 .09 4.43l-4.89 5.1zM41.16 31.38H45v-1.5h-3.84c-1.05-.03-1.86 1.08-1.53 2.07.56 1.82 1.69 6.3-.01 8.62-1.24 2-6.09 2-7.32 0-1.7-2.31-.58-6.79-.01-8.62.34-.99-.48-2.1-1.53-2.07h-2.97c-.6-.04-1.17.2-1.53.69-.32.44-.41.99-.25 1.5.63 2.03 1.88 7.02-.02 9.61-1.4 2.25-6.84 2.25-8.23 0-1.91-2.6-.65-7.58-.02-9.6.36-1.06-.51-2.23-1.63-2.2h-3.8c-.87-.02-1.57.91-1.29 1.74.8 2.57.81 4.74.03 5.8-.78 1.27-3.96 1.27-4.74 0-.78-1.06-.77-3.23.03-5.79.29-.83-.41-1.77-1.29-1.75.01-.01-2.05-.01-2.05-.01v1.5h1.85c-.55 1.84-1.17 5 .26 6.93 1.34 2.08 5.82 2.08 7.16 0 1.37-1.86.85-4.85.32-6.72-.03-.11.05-.21.17-.21h3.36c.08 0 .14.05.17.09-.67 2.87-2.08 7.96.27 11.1 1.96 3.06 8.68 3.07 10.65 0 2.23-3.03 1.11-8.15.25-10.94-.03-.15.03-.23.18-.25h3.13l.09.13c-1.51 4.45-2.07 12.15 5.11 12.05 7.18.1 6.61-7.6 5.11-12.05 0 0-.06-.13.09-.13z"
            }
          ),
          /* @__PURE__ */ e.jsx(
            "path",
            {
              fill: "#1D1D44",
              d: "M30.44 4.87c-5.06 9-7.96 17.15-5.2 31.79 1.21 6.43-7.65 6.48-6.79-.04C20 24.99 24.14 12.16 30.44 4.87M43.63 7.46c-4.53 8.06-7.13 15.35-4.65 28.46 1.09 5.75-6.85 5.8-6.07-.04C34.29 25.47 38 13.98 43.64 7.46zM13.06 18.33c-2.58 4.59-4.06 8.74-2.65 16.21.62 3.28-3.9 3.3-3.46-.02.79-5.93 2.9-12.47 6.11-16.19"
            }
          )
        ]
      }
    )
  }
));
i.displayName = "HairFeelBetterIcon";
export {
  i as HairFeelBetterIcon,
  i as default
};
//# sourceMappingURL=index.js.map
